var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLongView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5200_63884)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.799805 2.76344L0.799805 13.2362C0.799805 13.757 1.00669 14.2564 1.37494 14.6247C1.74319 14.9929 2.24265 15.1998 2.76344 15.1998H13.2362C13.757 15.1998 14.2564 14.9929 14.6247 14.6247C14.9929 14.2564 15.1998 13.757 15.1998 13.2362V2.76344C15.1998 2.24265 14.9929 1.74319 14.6247 1.37494C14.2564 1.00669 13.757 0.799805 13.2362 0.799805L2.76344 0.799805C2.24265 0.799805 1.74319 1.00669 1.37494 1.37494C1.00669 1.74319 0.799805 2.24265 0.799805 2.76344ZM2.1089 13.2362L2.1089 2.76344C2.1089 2.58985 2.17786 2.42336 2.30061 2.30061C2.42336 2.17786 2.58984 2.1089 2.76344 2.1089L6.03617 2.1089L6.03617 13.8907H2.76344C2.58985 13.8907 2.42336 13.8218 2.30061 13.699C2.17786 13.5763 2.1089 13.4098 2.1089 13.2362ZM11.2725 13.8907V2.1089H9.96344V13.8907H11.2725ZM7.34526 13.8907L7.34526 2.1089L8.65435 2.1089L8.65435 13.8907H7.34526ZM13.699 13.699C13.8218 13.5763 13.8907 13.4098 13.8907 13.2362V2.76344C13.8907 2.58984 13.8218 2.42336 13.699 2.30061C13.5763 2.17786 13.4098 2.1089 13.2362 2.1089H12.5816V13.8907H13.2362C13.4098 13.8907 13.5763 13.8218 13.699 13.699Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5200_63884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongView);
export default __webpack_public_path__ + "static/media/longView.17f69fa180d323ced6fc19166439f5f7.svg";
export { ForwardRef as ReactComponent };